export default __webpack_public_path__ + "static/media/round-grey.d519b433.png";